/* eslint-disable camelcase */
import {
  Row,
  Col,
  // Card,
  Space,
  Button,
} from 'antd';
// import TypographyTitle from '../../components/common/Title';
import {
  InfoCircleOutlined,
} from '@ant-design/icons';
import './index.css'
import { Link, useParams } from 'react-router-dom';
import { getFixtures } from '../../apis/fixture.api';
import { useEffect, useState } from 'react';
import { DEFAULT_LEAGUE_LINK, DEFAULT_TEAM_LINK, PAGE_TITLES } from '../../utils/constant';
import Loader from '../../components/common/Loader';
import Title from 'antd/es/typography/Title';
import { styles } from '../../styles';
import { useMediaQuery } from '../../hooks/MediaQuery.hook';
import { getTimer } from '../../utils/timer';
import MainDescription, { HOME_FAQS } from '../Description';
import { getCategoryType } from '../../utils';
import Seo from '../../components/Seo';
import {
  DEFAULT_KEYWORDS,
  PAGE_SEO,
  faqJsonLd,
} from '../../utils/seo';

  const headerStyle: any = {
    display: 'flex',
    justifyContent: 'flex-start',
  };

  const iconStyle = {
    color: '#adc6ff',
    marginRight: '10px',
    fontSize: '21px',
    strokeWidth: '15px',
    alignItems: 'middle'
  };

export default  function  Home() {
  const matches = useMediaQuery('(min-width: 1000px)');
  const [fixtures, setFixtures] = useState<any>({});
  const [noFixtures, setNoFixtures] = useState<boolean>(false);
  const { categoryName } = useParams();
  const [loader, setLoader] = useState<boolean>(false);
  const buttonSize = matches ? 'large': 'small';
  const spanSize = matches ? 20: 24;


  const getAllFixtures = async ()=> {
    setLoader(true);

    const response: any = await getFixtures({ categoryName: categoryName });
    if(!response?.data?.subCategories[0]?.games?.length){
      setNoFixtures(true);
    }else{
      setNoFixtures(false);
    }
    setFixtures(response.data);
    setLoader(false);
  }

  function SubCategoryCard({ subCategory }: any) {
    return (
      <Col style={{marginBottom: '1rem', justifyContent:'center', background: 'rgb(41,40,40)', borderRadius: '10px'}} span={24}>
        <div>
          <div  style={headerStyle}>
            <span style={styles.category}>
            
            { subCategory?.subCategoryImage ? 
            <img style={{width: '30px', paddingRight: '10px'}} 
            src={subCategory?.subCategoryImage} 
            alt={subCategory?.subCategoryName} 
            />: <InfoCircleOutlined style={iconStyle} />}
            {subCategory?.subCategoryName.toUpperCase()}
            </span>
          </div>
          <Row gutter={24}>
            {subCategory?.games?.map((fixture: any, index: any) => (
              <Col span={12} key={index} style={{ padding:'0px' }}>
                {matches ? <FixtureCard key={index} fixture={{...fixture, subCategoryName: subCategory?.subCategoryName}} />:
                <FixtureCardMobile key={index} fixture={{...fixture, subCategoryName: subCategory?.subCategoryName}} />
                }
              </Col>
              ))
            }
          </Row>
        </div>
      </Col>
    );
  }

  function Timer({ timerValue }: any) {
    return (
      <strong style={timerValue === 'Live' ? { color: 'red' } : {}}>{timerValue}</strong>
    );
  }

  function YoutubeHighlightsLink() {
    return (
      <Button
      type="primary"
      className="watch-highlights-btn"
    >
      ▶ Highlights
    </Button>
    );
  }

  function CardContent({ fixture }: any) {
    return (
      <div className='fixture-card'>
        <div className='fixture-link'>
        <div className='category'>
            <p>
              {getCategoryType(fixture?.subCategoryName)}
            </p>
            <p className='dash'></p>
          </div>
          <div className='flex-display'>
              <p className='team-name'>
                {fixture.teamAImage && <span style={styles.flexDisplay}>
                  <img className='fixture-image' style={{marginLeft: '0px'}} src={fixture.teamAImage} alt={fixture.teamA} />
                </span>}
                <strong>{fixture.teamA}</strong>{' '}
              </p>
              {fixture?.teamB ? <p className='verses'>vs</p>: ''}
              {fixture?.teamB && <p className='team-name'>
                <strong>{fixture.teamB}</strong>{' '}
                {fixture.teamBImage && <span style={styles.flexDisplay}>
                  <img className='fixture-image' src={fixture.teamBImage} alt={fixture.teamB} />
                </span>}
              </p>}
          </div>
        </div>
        {fixture?.matchDate && (
          <p className='match-time'>
            <Timer timerValue={getTimer(fixture)}></Timer>
        </p>)}
        {!fixture?.matchDate && <YoutubeHighlightsLink />}
      </div>
    );
  }

  function FixtureCard({ fixture }: any) {
    let link = `https://sportsfeed24.pk/fixture/${fixture.teamA}-vs-${fixture.teamB}`;
    if(!fixture?.matchDate) {
      const home = fixture?.teamA ?? '';
      const away = fixture?.teamB ?? '';
      const league = fixture?.subCategoryName ?? '';

      const query = encodeURIComponent(
        `${home} vs ${away} highlights ${league}`
      );

      link = `https://www.youtube.com/results?search_query=${query}`;
    }

    return fixture?.matchDate ? (
      <Link
        to={link}
      >
        <CardContent fixture={fixture} />
      </Link>
    ) : (
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <CardContent fixture={fixture} />
      </a>
    );
  }

  function FixtureCardMobile({ fixture }: any) {
    return (
      <Link 
      to={'https://sportsfeed24.pk/fixture/' + (fixture?.teamB ? fixture.teamA + '-vs-' + fixture.teamB : fixture.teamA)}
      rel="noopener noreferrer"
      >
        <div className='fixture-card'>
          <p className='team-name'>
            {fixture.teamAImage && <img className='fixture-image' style={{...styles.flexDisplay, marginLeft: '0px'}} src={fixture.teamAImage} alt={fixture.teamA} />}
            <strong> {fixture.teamA}</strong>{' '}
          </p>
          <p className='match-time'>
              <Timer timerValue={getTimer(fixture)}></Timer>
          </p>
          {fixture?.teamB && <p className='team-name'>
            <strong>{fixture.teamB}</strong>{' '}
            {fixture.teamBImage && <span>
              <img className='fixture-image' style={styles.flexDisplay} src={fixture.teamBImage} alt={fixture.teamB} />
            </span>}
          </p>}
        </div>
      </Link>
    );
  }

  useEffect(() => {
    document.title = categoryName ? PAGE_TITLES[categoryName.toUpperCase()]: PAGE_TITLES.WEBSITE_TITLE;
    getAllFixtures();
  }, [categoryName]);

  const categoryKey = categoryName ? categoryName.toUpperCase() : 'HOME';
  const pageSeo = PAGE_SEO[categoryKey] || PAGE_SEO.HOME;

  return (
    <>
      <Seo
        title={pageSeo.title}
        description={pageSeo.description}
        keywords={categoryName ? undefined : DEFAULT_KEYWORDS}
        jsonLd={!categoryName ? faqJsonLd(HOME_FAQS) : undefined}
      />
      {/* <Teams></Teams> */}
      {!loader && <>
        <Row style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>
          <Col span={spanSize} style={{paddingRight: '12px'}}>
            <Row className='flex-display'>
              <Space style={matches ? { marginBottom:'15px'}: { marginBottom: '5px'}} wrap>
                <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                  <Link to={DEFAULT_LEAGUE_LINK} >Leagues</Link>
                </Button>
                <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                  <Link to={DEFAULT_TEAM_LINK} >Teams</Link>
                </Button>
                <Button className='time-button' style={{ backgroundColor: '#202024', color:'#c7bdbd' }} shape="round" size={buttonSize}>
                  <Link to={'/leagues/standings'} >Standings</Link>
                </Button>
              </Space>
            </Row>
            {/* <AdSenseBanner slot={ADS.MAIN.SLOT} type={ADS.MAIN.TYPE} /> */}
          </Col>
            {/* <AdSenseBanner slot="7807264218" type='square-display' /> */}
        </Row>
        <Row gutter={24} style={{display: 'flex', justifyContent: 'center'}}>
          <Col span={spanSize} style={{ marginTop: '12px', padding: matches ? '0px': '12px' }}>
            {categoryName && (
              <h1 style={{ color: '#fff', fontSize: matches ? '28px' : '22px' }}>
                {categoryName} fixtures and schedule
              </h1>
            )}
            {categoryName && noFixtures ? 
            <div>
              <Title level={3}>No Fixtures Found For {categoryName.toUpperCase()}</Title>
              <Title level={3}>
                <Link to='/'><Button style={styles.homeButton}>Home</Button></Link>
              </Title>
            </div>:
              fixtures?.subCategories?.map((subCategory: any, index: any) => (
                subCategory?.games?.length > 0 ? (
                  <SubCategoryCard key={index} subCategory={{ ...subCategory }} />
                ) : null
              ))         
            }
          </Col>
          {/* {!loader && !categoryName &&<Col span={6}>
          {!categoryName && <div>
          <Row gutter={24} style={{display: 'flex', justifyContent: 'center'}}>
            <Link to={'/blogs'}>
              <h3 className='collection' style={{textAlign:'center'}}>Latest Feed</h3>
            </Link>
          </Row>
          <RelatedBlog excludedId={-1}></RelatedBlog>
        </div>}
          </Col>} */}
        </Row>
        <Row gutter={24} style={{display: 'flex', justifyContent: 'center'}}>
          <Col span={spanSize}>
          {!loader && !categoryName && <MainDescription></MainDescription>}
          </Col>
        </Row>
      </>}
      {loader ? <Loader /> : <></>}
    </>
  );
}
